import { useEffect, useState } from 'react';
import ChargerModule from '../../../components/chargerModule';
import ProductsListingTableHeader from './components/ProductsListingTableHeader/ProductsListingTableHeader';
import ProductsListingTableBody from './components/ProductsListingTableBody/ProductsListingTableBody';
import ProductsStockListing from './components/ProductsStockListing/ProductsStockListing';
import ProductsModuleListingFilters from './components/ProductsModuleListingFilters/ProductsModuleListingFilters';
import { ICountryDetail } from '../../../types/countries';
import { getListOfCountriesByOfferedService } from '../../../utils/getCountries';
import { ISharedModules } from 'types/orders';
import useFiltersState from 'state/useFiltersState';
import { LIST_PRODUCTS_TYPE } from '../../../types/orders';
import './ToolsModuleListing.scss';

/**
 * Componente principal para el listing del módulo de herramientas
 */
const ToolsModuleListing = () => {
  const { setToolsModuleListingSharedModule, toolsModuleListingSharedModule } = useFiltersState();

  const [searchText, setSearchText] = useState('');
  const [listOfCountries, setListOfCountries] = useState<ICountryDetail[]>();

  const [sharedModules, setSharedModules] = useState<ISharedModules[]>([
    { title: 'Clientes', key: 1, active: true },
    { title: 'Stock .Bord', key: 2, active: false }
  ]);

  const headerInfo = {
    title: 'Herramientas',
    subtitle: '',
    headerNote: ''
  };

  const clientsListingTab = toolsModuleListingSharedModule?.key === 1;
  const stockListingTab = toolsModuleListingSharedModule?.key === 2;

  const sharedModulesAction = (key: number) => {
    const newList = sharedModules?.map((module: ISharedModules) => {
      const moduleIsActive = module.key === key;
      const newModule = {
        key: module.key,
        title: module.title,
        active: moduleIsActive
      };
      if (moduleIsActive) setToolsModuleListingSharedModule(newModule);
      return newModule;
    });
    setSharedModules(newList);
  };

  const infoSideBar = { position: 'tools' };

  useEffect(() => {
    getListOfCountriesByOfferedService(setListOfCountries);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="toolsModuleListing">
      <ChargerModule
        headerInfo={headerInfo}
        infoSideBar={infoSideBar}
        viewSearchBar
        searchbarPlaceholder="Buscar por SN, Cliente, SKU, Nombre"
        searchText={searchText}
        setSearchText={setSearchText}
        sharedModule={toolsModuleListingSharedModule}
        sharedModulesAction={sharedModulesAction}
        sharedModules={sharedModules}
        customClassNameButtonMenu='buttonMenuTools'
        customClassNameModuleView='moduleViewTools'
      >
        {clientsListingTab && (
          <>
            <ProductsModuleListingFilters
              listOfCountries={listOfCountries || []}
              listProductsType={LIST_PRODUCTS_TYPE.CLIENTS}
            />
            <ProductsListingTableHeader listProductsType={LIST_PRODUCTS_TYPE.CLIENTS} />
            <ProductsListingTableBody searchText={searchText} listOfCountries={listOfCountries || []} />
          </>
        )}

        {stockListingTab && (
          <>
            <ProductsModuleListingFilters
              listOfCountries={listOfCountries || []}
              listProductsType={LIST_PRODUCTS_TYPE.STOCK_BORD}
            />
            <ProductsListingTableHeader listProductsType={LIST_PRODUCTS_TYPE.STOCK_BORD} />
            <ProductsStockListing searchText={searchText} listOfCountries={listOfCountries || []} />
          </>
        )}
      </ChargerModule>
    </div>
  );
};

export default ToolsModuleListing;
